import React from "react";
import PropTypes from "prop-types";
import FullCalendar from "@fullcalendar/react";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";

function TabOmat(props: {
  children: any;
  value: number;
  index: number;
  events: any;
  eventClick: any;
}) {
  const {
    value,
    index,
    events,
    eventClick,
  } = props;

  // filter events according to user
  const ownEvents = events
    .filter((event: any) => event.isOwn)
    .map((event: any) => Object.assign({}, event));

  // Override title of event to see arena in list
  ownEvents.forEach(
    (event: any) => (event.title = "Kenttä " + event.arena_number)
  );

  return (
    <div
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <div>
          <p className="App-p">
            Poista varaus klikkaamalla sitä listassa. Menneitä varauksia ei voi
            poistaa.
          </p>
          <p className="App-p">
            HUOM! Listalla näkyy nyt koko kuukauden varaukset.
          </p>
          <FullCalendar
            events={ownEvents}
            locale="fi"
            timeZone="Europe/Helsinki"
            initialView="listMonth"
            slotMinTime="07:00"
            slotMaxTime="22:00"
            firstDay={1}
            weekNumbers={true}
           // weekLabel="viikko"
            allDaySlot={false}
            slotLabelInterval="00:30"
            slotLabelFormat={{
              hour: "numeric",
              minute: "2-digit",
              omitZeroMinute: false,
              meridiem: "short",
            }}
            plugins={[listPlugin, interactionPlugin]}
            eventClick={eventClick}
            buttonText={{
              today: "Tänään",
              month: "Kuukausi",
              week: "Viikko",
              day: "Päivä",
              list: "Lista",
            }}
            displayEventTime={true}
            contentHeight={600}
            //noEventsMessage="Ei varauksia tässä kuussa."
          />
        </div>
      )}
    </div>
  );
}

TabOmat.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default TabOmat;
